import {decodeRangedMediaAudio} from './rangedMediaAudio.js';
// Web Audio's clock provides accurate start/end boundaries for normal passages.
// If the browser cannot grant ranged/CORS reads, the caller can play the
// exact selected video segment natively without discarding the edit.
export function playbackSegments(clips,sourceTime,restart=false){
 let index=restart?0:clips.findIndex(c=>sourceTime>=c.start&&sourceTime<c.end);
 if(index<0)index=0;
 return clips.slice(index).map((c,i)=>({...c,start:i===0&&!restart&&sourceTime>=c.start&&sourceTime<c.end?sourceTime:c.start}));
}
export class PrecisePreview {
 constructor(context){this.context=context;this.nodes=[];this.buffer=null;this.url=null;this.run=null;this.generation=0;this.ranged=null;}
 async prepare(url,duration,clip){
  await this.context.resume();
  if(!clip||!Number.isFinite(clip.start)||!Number.isFinite(clip.end))
   throw new Error('Choose a timed passage to preview.');
  if(clip.start<0||clip.end<=clip.start||clip.end>duration+.1)
   throw new Error('This passage has invalid source timecodes.');
  const key=url+'|'+clip.start+'|'+clip.end;
  if(this.ranged?.key===key&&this.buffer)return;
  const generation=this.generation;
  const buffer=await decodeRangedMediaAudio(url,clip.start,clip.end,this.context);
  if(generation!==this.generation)return;
  this.buffer=buffer;this.url=url;this.ranged={key,start:clip.start,end:clip.end};
 }
 start(clips,sourceTime,restart=false){
  this.stop();
  if(!this.buffer)throw new Error('Audio is not ready.');
  const segments=playbackSegments(clips,sourceTime,restart);
  if(!segments.length)return;
  if(this.ranged && (segments.length!==1||
    segments[0].start<this.ranged.start-.0001||segments[0].end>this.ranged.end+.0001))
   throw new Error('Precise preview needs the selected audio range.');
  let offset=0;
  const origin=this.context.currentTime+0.04;
  const schedule=segments.map(segment=>{
   const duration=segment.end-segment.start;
   const node=this.context.createBufferSource();node.buffer=this.buffer;node.connect(this.context.destination);
   const bufferOffset=this.ranged?segment.start-this.ranged.start:segment.start;
   node.start(origin+offset,bufferOffset,duration);this.nodes.push(node);
   const entry={...segment,offset,duration};offset+=duration;return entry;
  });
  this.run={origin,schedule,duration:offset};
 }
 position(){
  if(!this.run)return null;
  const time=Math.max(0,this.context.currentTime-this.run.origin);
  const segment=this.run.schedule.find(c=>time<c.offset+c.duration)||this.run.schedule.at(-1);
  return {id:segment.id,source:Math.min(segment.end,segment.start+Math.max(0,time-segment.offset)),ended:time>=this.run.duration};
 }
 stop(){for(const node of this.nodes){try{node.stop();}catch{/* Already ended. */}node.disconnect();}this.nodes=[];this.run=null;}
 dispose(){this.generation++;this.stop();this.buffer=null;this.url=null;this.ranged=null;this.context.close().catch(()=>{});}
}
